import { addVehicleModel, fetchVehicleModels } from '../../../components/qv4/models/shared/vehiclesModel';
export async function addTemporaryVehicleModel(makeId, name) {
  const result = await addVehicleModel(makeId, name);
  if (!result?.success) throw new Error(result?.message || 'The temporary model could not be saved.');
  const rows = await fetchVehicleModels(makeId);
  const matches = rows.filter(row => String(row.label).trim() === name.trim());
  if (matches.length !== 1) throw new Error('The saved model is ambiguous. Reload the vehicle form before continuing.');
  return matches[0].value;
}
